document.addEventListener('DOMContentLoaded', () => {
	const filter = document.getElementById('js-category-filter');
	const toggle = document.getElementById('js-category-filter-toggle');
	if (!filter || !toggle) return;

	const close = () => {
		filter.classList.remove('is-active');
		toggle.setAttribute('aria-expanded', 'false');
	};

	toggle.addEventListener('click', () => {
		const isActive = filter.classList.toggle('is-active');
		toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
	});

	document.addEventListener('click', (e) => {
		if (!filter.contains(e.target)) close();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') close();
	});
});
